import { Outlet } from "react-router";
import styles from "./CommandCenterContainer.module.scss";
import { NotificationPermitter } from "../../components/NotificationPermitter/NotificationPermitter";
import {
  useCenterLogisticsSSEHandlers,
  useCenterPatientSSEHandlers,
} from "@/Utils/sseHandlers";
import Header from "@/pages/commandcenter/Header";
import { useAppVisibilityBreadcrumbs } from "../useAppVisibilityBreadcrumbs";
import { ChatProvider } from "./ChatProvider";
import { SelectedDateContextProvider } from "./SelectedDateContextProvider";
import { SidePanel } from "./SidePanel/SidePanel";
import { useSidePanel } from "./SidePanel/useSidePanel";
import { knownFeatureFlagsSchema, useFeatureFlag } from "@/api/FeatureFlags";

const browserSupportsNotificationAPI = "Notification" in window;

const CommandCenterContainer = () => {
  useAppVisibilityBreadcrumbs();

  const { data: isAIPlatformAssistantEnabled } = useFeatureFlag(
    knownFeatureFlagsSchema.enum.AIPlatformAssistantInCenter,
  );
  useCenterLogisticsSSEHandlers();
  useCenterPatientSSEHandlers();
  const { showSidePanel } = useSidePanel();
  return (
    <div className={styles.rootContainer}>
      <div className={styles.commandCenterContainer}>
        <ChatProvider>
          <Header />
          <section className={styles.banners}>
            {browserSupportsNotificationAPI ? <NotificationPermitter /> : <></>}
          </section>
          <main className={styles.main}>
            <SelectedDateContextProvider>
              <Outlet />
            </SelectedDateContextProvider>
          </main>
        </ChatProvider>
      </div>
      {isAIPlatformAssistantEnabled && showSidePanel && (
        <aside className={styles.aside}>
          <SidePanel />
        </aside>
      )}
    </div>
  );
};

export default CommandCenterContainer;
